/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the UploadUserFileRequest interface.
 */
export function instanceOfUploadUserFileRequest(value) {
    let isInstance = true;
    return isInstance;
}
export function UploadUserFileRequestFromJSON(json) {
    return UploadUserFileRequestFromJSONTyped(json, false);
}
export function UploadUserFileRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uploadFileName': !exists(json, 'uploadFileName') ? undefined : json['uploadFileName'],
        'uploadMimeType': !exists(json, 'uploadMimeType') ? undefined : json['uploadMimeType'],
        'uploadFileSize': !exists(json, 'uploadFileSize') ? undefined : json['uploadFileSize'],
    };
}
export function UploadUserFileRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uploadFileName': value.uploadFileName,
        'uploadMimeType': value.uploadMimeType,
        'uploadFileSize': value.uploadFileSize,
    };
}
